import { useMaverick } from "@/data/maverick/context";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Zap, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Persistent banner shown on non-Maverick screens when the user
 * was routed there by Maverick Mode to complete a task.
 */
export function MaverickHandoffBanner() {
  const { state, clearHandoff, enableMaverick } = useMaverick();
  const navigate = useNavigate();
  const handoff = state.handoff;

  if (!handoff) return null;

  const handleReturn = () => {
    clearHandoff();
    enableMaverick();
    navigate("/demo-lab");
  };

  return (
    <div className="bg-primary/5 border-b border-primary/20 px-4 py-2 flex items-center justify-between gap-4 shrink-0">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-7 w-7 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
          <Zap className="h-3.5 w-3.5 text-primary" />
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-[11px] font-bold text-primary uppercase tracking-wide">Maverick Task</p>
            <span className="text-[10px] text-muted-foreground font-mono">{handoff.jobId}</span>
          </div>
          <p className="text-xs text-foreground font-medium truncate mt-0.5">
            {handoff.taskLabel} — {handoff.customerName}
          </p>
          <p className="text-[10px] text-muted-foreground mt-0.5 truncate">
            {handoff.instruction}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          className="gap-1.5 text-xs font-semibold shrink-0"
          onClick={handleReturn}
        >
          <ArrowLeft className="h-3 w-3" />
          Return to Maverick
        </Button>
      </div>
    </div>
  );
}
